import { render, staticRenderFns } from "./OnboardCard.vue?vue&type=template&id=6b3c68e0&scoped=true&"
import script from "./OnboardCard.vue?vue&type=script&lang=js&"
export * from "./OnboardCard.vue?vue&type=script&lang=js&"
import style0 from "./OnboardCard.vue?vue&type=style&index=0&id=6b3c68e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c68e0",
  null
  
)

export default component.exports